import React from "react";
export function Card({ title, action, children, padded = true, style = {} }) {
  return (
    <div style={{ background: "var(--bg-card)", border: "1px solid var(--line-e)", borderRadius: "var(--r-card)", display: "flex", flexDirection: "column", overflow: "hidden", ...style }}>
      {title ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, padding: "11px 14px", borderBottom: "1px solid var(--line-f)" }}>
          <span style={{ fontSize: "var(--fs-12)", fontWeight: "var(--fw-semibold)", color: "var(--fg-1)" }}>{title}</span>
          {action}
        </div>
      ) : null}
      <div style={{ flex: 1, minHeight: 0, padding: padded ? "12px 14px" : 0 }}>{children}</div>
    </div>
  );
}
